import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import monogramHealthPic3 from "../../Assets/Projects/monogramHealthPic3.png";
import monogramHealthPic4 from "../../Assets/Projects/monogramHealthPic4.png";
import employeeManagement from "../../Assets/Projects/empoyeemanagement.png";
import friendsApp from "../../Assets/Projects/friendsApp.png";
import friendsApp2 from "../../Assets/Projects/friendsApp2.png";
import courseSell from "../../Assets/Projects/placementcell.png";

const PROJECTS = [
  {
    images: [monogramHealthPic3, monogramHealthPic4],
    title: "Healthcare Management Platform",
    description:
      "A comprehensive healthcare SaaS portal improving patient outcomes via appointment booking, health report access, and real-time provider-patient communication. Built responsive, mobile-first UIs with Next.js 13+ and Tailwind CSS (WCAG compliant), integrated RESTful APIs supporting 5,000+ concurrent users, and improved API response time by 40% through Redis caching — reducing server load by 30%.",
    techStack: ["Next.js", "TypeScript", "React.js", "Redux Toolkit", "Tailwind CSS", "Redis", "WebSockets", "TanStack Query"],
    ghLink: null,
    demoLink: "https://www.monogramhealth.com",
  },
  {
    images: [friendsApp, friendsApp2],
    title: "Friends App – Video Calling & Chat Platform",
    description:
      "A full-stack real-time SaaS platform enabling users to connect, chat, and make peer-to-peer video calls using WebRTC. Features secure JWT authentication, role-based access control (RBAC), low-latency messaging via WebSockets and Stream Chat SDK, and unit-tested authentication & API flows.",
    techStack: ["React.js", "Node.js", "MongoDB", "WebSockets", "WebRTC", "Stream Chat", "Redux Toolkit", "Tailwind CSS"],
    ghLink: "https://github.com/chandraprakash9589/Friends-app",
    demoLink: "https://friends-app-rust.vercel.app/",
  },
  {
    imgPath: courseSell,
    title: "CourseSell — Course Selling Platform",
    description:
      "A full-stack e-learning marketplace where users can browse courses by category & level, register/login with JWT auth, purchase courses via Razorpay checkout, and track orders in a personal dashboard. Implements HMAC SHA256 signature verification for secure payment confirmation.",
    techStack: ["Next.js 14", "Node.js", "Express.js", "MongoDB", "Razorpay", "JWT", "Tailwind CSS"],
    ghLink: "https://github.com/chandraprakash9589/nextjs-node-payment-app",
    demoLink: "https://nextjs-node-payment-app.vercel.app/",
  },
  {
    imgPath: employeeManagement,
    title: "Employee Management Portal",
    description:
      "An enterprise employee management system serving 200+ employees with real-time updates, leave management, daily standups, and performance tracking. JWT-based auth with RBAC across 5 user roles. MongoDB indexing + Redis caching reduced query time by 50%. Deployed on AWS EC2 with Docker, CI/CD via GitHub Actions, and AWS SNS/SQS for notifications.",
    techStack: ["React.js", "Node.js", "MongoDB", "Redis", "AWS", "Docker", "TanStack Query", "Tailwind CSS"],
    ghLink: "https://github.com/chandraprakash9589/Employees-management",
    demoLink: "https://employees-management-lemon.vercel.app/",
  },
];

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works</strong>
        </h1>
        <p style={{ color: "rgba(255,255,255,0.65)", fontSize: "1.05em" }}>
          Production-grade applications spanning healthcare SaaS, real-time communication, e-commerce, and enterprise tooling.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          {PROJECTS.map((project) => (
            <Col xs={12} sm={12} md={4} className="project-card" key={project.title}>
              <ProjectCard
                images={project.images}
                imgPath={project.imgPath}
                isBlog={false}
                title={project.title}
                description={project.description}
                techStack={project.techStack}
                ghLink={project.ghLink}
                demoLink={project.demoLink}
              />
            </Col>
          ))}
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
